import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { getURLParams } from '../utils/helper';
import { codeAtom } from '../jotai/atoms/code';
import { kreedaAtom } from '../jotai/atoms/kreeda';
import { quizSubmissionAtom } from '../jotai/atoms/quiz';
import { crosswordSubmissionAtom } from '../jotai/atoms/crossword';
import { Code } from './Code';
import { Page } from './UI/Page';
import { Error } from './Error';
const App = () => {
    const queryParams = getURLParams();
    const [code, setCode] = useAtom(codeAtom);
    const [kreedaQuery] = useAtom(kreedaAtom);
    const [quizMutation] = useAtom(quizSubmissionAtom);
    const [crosswordMutation] = useAtom(crosswordSubmissionAtom);
    // Destructure with proper checks
    const { data: kreeda, isLoading: isKreedaLoading, isError: isKreedaError, error: kreedaError, } = kreedaQuery;
    const { mutate: mutateQuiz, status: quizStatus, isError: isQuizError, error: quizError, } = quizMutation;
    const { mutate: mutateCrossword, status: crosswordStatus, isError: isCrosswordError, error: crosswordError, } = crosswordMutation;
    const handleCodeSubmit = (code) => {
        setCode(code);
    };
    const handleKreedaSubmit = (code, data) => {
        // Ensure kreeda is defined before accessing its properties
        if (!kreeda) {
            console.error('Kreeda is not defined');
            return;
        }
        if (kreeda.kreedaType === 'Quiz') {
            mutateQuiz({ code, data: data });
        }
        else if (kreeda.kreedaType === 'Crossword') {
            mutateCrossword({ code, data: data });
        }
    };
    // Initialize code from URL params
    useEffect(() => {
        if (queryParams.code && queryParams.code.trim() !== '') {
            setCode(queryParams.code);
        }
    }, [queryParams.code, setCode]);
    // Loading states
    if (isKreedaLoading ||
        quizStatus === 'pending' ||
        crosswordStatus === 'pending') {
        return (React.createElement("div", { className: "loader-container" },
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("div", { className: "loader" },
                        React.createElement("div", { className: "child" }))),
                React.createElement("li", null,
                    React.createElement("div", { className: "text" })))));
    }
    // Error states
    if (isKreedaError) {
        return (React.createElement(Error, { message: kreedaError?.message || 'An error occurred' }));
    }
    if (isQuizError) {
        return (React.createElement(Error, { message: quizError?.message || 'Quiz submission failed' }));
    }
    if (isCrosswordError) {
        return (React.createElement(Error, { message: crosswordError?.message || 'Crossword submission failed' }));
    }
    // No code provided - show code input
    if (!code) {
        return (React.createElement("div", { className: "page" },
            React.createElement(Code, { onSubmit: handleCodeSubmit })));
    }
    // Code provided but kreeda not loaded yet - this should show loading above
    // But if we reach here, it means code exists but kreeda failed to load
    if (!kreeda) {
        return (React.createElement(Error, { message: "Failed to load kreeda. Please check the code and try again." }));
    }
    // Validate kreeda has required properties
    if (!kreeda.kreedaType || !kreeda.kreedaData) {
        return React.createElement(Error, { message: "Invalid kreeda data received. Please try again." });
    }
    // Type guard to ensure kreeda matches Page component expectations
    // const validatedKreeda = {
    //   kreedaType: kreeda.kreedaType,
    //   kreedaData: {
    //     name: (kreeda.kreedaData as any).name || 'Unknown',
    //     duration: (kreeda.kreedaData as any).duration || '0',
    //   },
    // };
    // Kreeda is defined and validated - show the main page
    return React.createElement(Page, { code: code, kreeda: kreeda, onSubmit: handleKreedaSubmit });
};
export { App };
